"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gotti_1 = require("gotti");
let Island = require("../Engine/Client/Games/Island");
Island = Island.default && Island.__esModule ? Island.default : Island;
const gameProcessSetups = [];
gameProcessSetups.push({
    areas: Island.areas.map(a => {
        return {
            type: a.type,
            systems: [...a.systems],
            plugins: a.plugins ? [...a.plugins] : null,
        };
    }),
    fps: Island.fps ? Island.fps : 60,
    globals: Island.globals ? Island.globals : null,
    isNetworked: 'isNetworked' in Island ? Island.isNetworked : true,
    plugins: Island.plugins ? Island.plugins : null,
    systems: Island.systems,
    type: Island.type,
});
const gottiClient = new gotti_1.Client(gameProcessSetups, null, false, 'http');
console.log("created gotti client", gottiClient);
const vue_1 = require("vue");
const ProdApp_vue_1 = require("./ProdApp.vue");
vue_1.default.config.productionTip = false;
new vue_1.default({
    render: h => h(ProdApp_vue_1.default),
}).$mount('#app');
//# sourceMappingURL=module.js.map